/** Kleines Pill-Label mit der Sektion eines Todos — `null` = "Allgemein". */
export function TodoSectionTag({ name }: { name: string | null }) {
  return (
    <span className={`todo-section-tag${name ? '' : ' is-general'}`}>{name ?? 'Allgemein'}</span>
  );
}
